/**
 * WordPress dependencies
 * @wordpress/i18n for translation functions
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 * - Should basically always be used for any text that is visible to the user
 *
 * @wordpress/element for React components
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-element/
 */
import CourseListItem from './CourseListItem';

/**
 * Example Component
 * @param {Object.data} data Data from UseInfiniteQuery and useRecipes hook
 * @param {Object.currentPage} currentPage The current page of the recipe list
 * @param {Object.isPending} isPending Whether the loading is pending or not (from useIndustries hook)
 * @param {Object.error} error The error of the data fetch (from useRecipes hook)
 * @param {Object.isError} isError Whether the fetch has an error or not (from useIndustries hook)
 * @returns {JSX.Element}
 */
function CourseList({ instances, month }) {
	if (!instances || !instances.length) {
		return;
	}

	return (
		<div className="course__list-container">
			<h2>{month}</h2>
			<ul className="course__list">
				{instances.map((instance) => {
					return (
						<CourseListItem key={instance.id} props={instance} />
					);
				})}
			</ul>
		</div>
	);
}

export default CourseList;
